export function LegalNotice() {
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h1 className="text-4xl font-bold text-gray-900 mb-8">Aviso Legal</h1>

      <div className="prose prose-lg">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Datos identificativos</h2>
          <p>
            En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan los siguientes datos:
          </p>
          <ul className="list-disc pl-6 mt-4 space-y-2">
            <li>Razón social: Transcaravan Galicia SL</li>
            <li>CIF: B32507808</li>
            <li>Domicilio: Calle Costa Castrelos 2, portal 5, 4A, 36213 Vigo (Pontevedra)</li>
            <li>Correo electrónico: info@furgosrio.com</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Objeto</h2>
          <p>
            El presente aviso legal regula el uso y utilización del sitio web www.furgosrio.com, del que es titular Transcaravan Galicia SL.
          </p>
          <p className="mt-4">
            La navegación por el sitio web atribuye la condición de usuario del mismo e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Responsabilidad</h2>
          <p>
            Transcaravan Galicia SL se exime de cualquier tipo de responsabilidad derivada de la información publicada en su sitio web cuando esta información haya sido manipulada o introducida por un tercero ajeno al mismo.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Propiedad intelectual e industrial</h2>
          <p>
            Transcaravan Galicia SL es titular de todos los derechos de propiedad intelectual e industrial de su página web, así como de los elementos contenidos en la misma (a título enunciativo: imágenes, sonido, audio, vídeo, software o textos; marcas o logotipos, combinaciones de colores, estructura y diseño, selección de materiales usados, programas de ordenador necesarios para su funcionamiento, acceso y uso, etc.).
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Modificaciones</h2>
          <p>
            Transcaravan Galicia SL se reserva el derecho a realizar las modificaciones que considere oportunas, sin aviso previo, en el contenido de su sitio web. Tanto en lo referente a los contenidos del sitio web, como en las condiciones de uso del mismo.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-4">6. Legislación aplicable y jurisdicción</h2>
          <p>
            La relación entre Transcaravan Galicia SL y el usuario se regirá por la normativa española vigente y cualquier controversia se someterá a los Juzgados y tribunales de la ciudad de Vigo.
          </p>
        </section>
      </div>
    </div>
  );
} 